import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import LoadingScreen from './components/LoadingScreen'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Order from './pages/Order'
import VendorPartnership from './pages/VendorPartnership'
import DownloadApp from './pages/DownloadApp'
import TermsOfUse from './pages/TermsOfUse'
import DataProtection from './pages/DataProtection'
import AdminPanel from './pages/AdminPanel'
import ScrollToTop from './components/ScrollToTop'
import WhatsAppButton from './components/WhatsAppButton'

function App() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const hasVisited = sessionStorage.getItem('hasVisited')
    if (hasVisited) {
      setIsLoading(false)
    }
  }, [])

  const handleLoadingComplete = () => {
    sessionStorage.setItem('hasVisited', 'true')
    setIsLoading(false)
  }

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading && <LoadingScreen onLoadingComplete={handleLoadingComplete} />}
      </AnimatePresence>
      
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/mgmt8x2k7p" element={<AdminPanel />} />
          <Route path="*" element={
            <div className="min-h-screen flex flex-col">
              <Navbar />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/order" element={<Order />} />
                  <Route path="/download-app" element={<DownloadApp />} />
                  <Route path="/partner-with-us" element={<VendorPartnership />} />
                  <Route path="/terms-of-use" element={<TermsOfUse />} />
                  <Route path="/data-protection" element={<DataProtection />} />
                </Routes>
              </main>
              <Footer />
              <WhatsAppButton />
            </div>
          } />
        </Routes>
      </Router>
    </>
  )
}

export default App
